import { useCallback, useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { copyActivityToClipboard } from "../lib/copyLesson";

export const CopyLessonButton = ({ activity, size = "md", testid = "copy-lesson" }) => {
  const [copied, setCopied] = useState(false);

  // Reset the "Copied!" label after 2 seconds.
  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(t);
  }, [copied]);

  const handleClick = useCallback(async () => {
    try {
      await copyActivityToClipboard(activity);
      setCopied(true);
      toast.success("Lesson copied", {
        description: "Paste it into email, Google Docs, or Word.",
      });
    } catch (e) {
      setCopied(false);
      toast.error("Copy failed", { description: e?.message || "Try again." });
    }
  }, [activity]);

  const pad = size === "sm" ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm";

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testid}
      aria-live="polite"
      className={`inline-flex items-center gap-2 rounded-md border border-[#4a6984]/20 bg-white text-[#4a6984] font-semibold hover:bg-[#f4f5f7] hover:border-[#4a6984]/35 transition-colors ${pad}`}
    >
      {copied ? (
        <>
          <Check className="h-3.5 w-3.5 text-[#1c2d3d]" />
          Copied
        </>
      ) : (
        <>
          <Copy className="h-3.5 w-3.5" />
          Copy
        </>
      )}
    </button>
  );
};

export default CopyLessonButton;
